import React from 'react';
import styles from './SectionTitle.module.css';

export default ({ children, size = 'h1' }) => {
  let title;
  switch (size) {
    case 'h1':
    default:
      title = (<h1 className={styles.title}>{children}</h1>);
      break;
    case 'h2':
      title = (<h2 className={styles.title}>{children}</h2>);
      break;
    case 'h3':
      title = (<h3 className={styles.title}>{children}</h3>);
      break;
    case 'h4':
      title = (<h4 className={styles.title}>{children}</h4>);
      break;
    case 'h5':
      title = (<h5 className={styles.title}>{children}</h5>);
      break;
    case 'h6':
      title = (<h6 className={styles.title}>{children}</h6>);
      break;
  }

  return (
    <div className={styles.titleWrap}>
      <div className={styles.colorBox} />
      {title}
    </div>
  );
};
